<template>
  <div>
    <div class="head-box">
      <h4>通知记录</h4>
      <div class="c-flex">
        <el-select
          v-model="Filter.channel"
          placeholder="请选择通知频道"
          clearable
          @change="
            fpi.page = 1;
            getData();
          "
          @clear="
            fpi.page = 1;
            getData();
          "
        >
          <el-option
            v-for="item in options.channel"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          class="c-m-l-15 search-input"
          placeholder="请输入通知内容"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table
          ref="table"
          :data="fpi.data"
          stripe
          height="calc(100% - 50px)"
          highlight-current-row
        >
          <el-table-column
            prop="data.receiveId"
            label="接收人"
            width="200px"
            show-overflow-tooltip
            :formatter="formatReceiveId"
          ></el-table-column>
          <el-table-column
            prop="data.receiveType"
            label="接收类型"
            width="100px"
            :formatter="formatReceiveType"
          ></el-table-column>
          <el-table-column
            prop="data.channel"
            label="通知频道"
            width="100px"
            :formatter="formatChannel"
          ></el-table-column>
          <el-table-column prop="createTime" label="接收时间" width="140px"></el-table-column>
          <!--<el-table-column prop="data.title" label="标题" width="150px">
          </el-table-column>-->
          <el-table-column prop="data.content" label="内容" show-overflow-tooltip></el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'notifications',
  data() {
    return {
      fpi: { data: [] },
      searchValue: '',
      Filter: {
        channel: ''
      },
      options: {
        channel: [
          { label: '短信', value: '1' },
          { label: '站内信', value: '2' },
          { label: '公众号通知', value: '3' },
          { label: '小程序通知', value: '4' }
        ]
      }
    };
  },
  mounted() {
    window.$this = this;
    this.getRoles();
  },
  methods: {
    formatReceiveId(row, column, cellValue, index) {
      var type = row.data.receiveType;
      if (type == 'personal') {
        return this.osg.codelabelForArray('users', cellValue);
      } else if (type == 'role') {
        return this.osg.codelabelForArray('roles', cellValue);
      } else {
        return '所有人';
      }
    },
    formatReceiveType(row, column, cellValue, index) {
      if (cellValue == 'personal') {
        return '人员';
      } else if (cellValue == 'role') {
        return '角色';
      } else if (cellValue == 'all') {
        return '所有人';
      }
    },
    formatChannel(row, column, cellValue, index) {
      return this.osg.codelabel('channel', cellValue);
    },
    //页码变更
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    //当前页变更
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    getData() {
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        smodule: 'notification',
        'regex:content|string#or': this.searchValue,
        'eq:data.channel|string#and': this.Filter.channel
      };
      this.osg.ajax('tenantLog/query.do', params, res => {
        if (res) {
          this.fpi = res;
          this.$nextTick(() => {
            this.$refs.table.doLayout();
            this.$forceUpdate();
          });
        }
      });
    },
    getRoles() {
      this.osg.ajax('role/query.do', { page: 1, rows: 100 }, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.roles = res.data;
        this.getUsers();
      });
    },
    getUsers() {
      var params = {
        page: 1,
        rows: 100,
        tenantId: this.tenantId
      };
      this.osg.ajax('user/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.users = res.data;
        this.getData();
      });
    }
  }
};
</script>
